import { useState, useEffect } from "react";
// redux
import { useSelector } from "react-redux";
// hooks
import usePageParams from "../../hooks/usePageParams";
// mui
import { Stack, Box } from "@mui/material";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// components
import {
    PageTitle,
    SortBox,
    SearchBox,
    PaginationFilter,
    LabelCard,
    LinkButton,
    ThreeDotsLoader,
    StatusFilterBox,
} from "../../components";
// icons
import { MdAdd } from "react-icons/md";
// alerts
import { errorAlert } from "../../utils/alerts/alerts";
// types
import { ReduxUserReducerState } from "../../types/global";

const Cities = () => {
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const { page, setPage } = usePageParams();
    const [sortValue, setSortValue] = useState<string>("-created_at");
    const [searchValue, setSearchValue] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(24);
    const [totalItems, setTotalItems] = useState(24);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [cities, setCities] = useState([]);
    const [dataChanged, setDataChanged] = useState(false);
    const [filterValues, setFilterValues] = useState<Record<string, string>>({
        status: "",
    });
    useEffect(() => {
        setLoading(true);
        EnhancedAxios(null, userToken)
            .get(
                `/admin/cities?sorts=${sortValue}&page=${page}&paginate=${itemsPerPage}&filters=${filterValues.status}`
            )
            .then((res: AxiosResponse) => {
                setCities(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
            });
    }, [page, itemsPerPage, sortValue, dataChanged, filterValues]);

    return (
        <Stack gap="20px">
            <PageTitle title="ادراة المدن" />
            <Stack>
                <LinkButton
                    text="اضافة مدينة"
                    to="/add-city"
                    icon={<MdAdd />}
                />
            </Stack>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                flexWrap="wrap"
            >
                <SearchBox
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />
                <SortBox sortValue={sortValue} setSortValue={setSortValue} />
                <StatusFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="20px"
                flexWrap="wrap"
            >
                {loading ? (
                    <ThreeDotsLoader />
                ) : cities.length === 0 ? (
                    <p>لا توجد عناصر لعرضها</p>
                ) : (
                    cities.map((city: any) => (
                        <LabelCard
                            key={city.id}
                            label={city.name}
                            id={city.id}
                            editPagePath={`/edit-city/${city.id}`}
                            endpointPath={`/admin/cities/${city.id}`}
                            is_disabled={city.is_disabled}
                            setDataChanged={setDataChanged}
                        />
                    ))
                )}
            </Box>
            <PaginationFilter
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                currentPage={page}
                setCurrentPage={setPage}
            />
        </Stack>
    );
};

export default Cities;
